module.exports = __webpack_public_path__ + "img/new-icon.63a96f2e.svg";